import React from "react";
import styles from "./journey.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { journey } from "../../../../CONTENT/physicians";

const Journey = () => {
  let n = 0;
  return (
    <Section tone="cloud" id="journey" labelledBy="journey-title">
      <SectionIntro
        id="journey-title"
        eyebrow="Starting research with your practice"
        title="Two phases, then KUR runs it with you."
        lead="Every partnership starts with an assessment of fit, then moves through implementation to your first enrolled patient."
      />
      <div className={styles.phases}>
        {journey.map((phase, pi) => (
          <div key={phase.id} id={phase.id} className={styles.phase}>
            <div className={styles.phaseHead}>
              <p className={styles.phaseNum}>Phase {pi + 1}</p>
              <h3 className={styles.phaseTitle}>{phase.phase}</h3>
            </div>
            <ol className={styles.steps}>
              {phase.steps.map((s) => {
                n += 1;
                return (
                  <Reveal as="li" key={s.title} className={styles.step}>
                    <span className={styles.dot} aria-hidden="true">
                      {n}
                    </span>
                    <h4 className={styles.stepTitle}>{s.title}</h4>
                    <p className={styles.stepText}>{s.text}</p>
                  </Reveal>
                );
              })}
            </ol>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Journey;
